<template>
  <div class="page">
    <a-card title="营销设置" :bordered="false" :bodyStyle="{paddingTop:'10px'}"
            :headStyle="{ borderBottom: '0px', fontSize: '18px' }">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item prop="productDetailStatus" label="商品详情展示">
          <a-radio-group v-model="ruleForm.productDetailStatus">
            <a-radio :value="1">开启</a-radio>
            <a-radio :value="0">关闭</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item prop="showType" label="展示模式">
          <a-radio-group v-model="ruleForm.showType">
            <a-radio :value="1">公众号吸粉模式</a-radio>
            <a-radio :value="2">直接扫码</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="群头像" prop="groupHeadImg">
          <div class="upload-box">
            <a-upload
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :action="actionImageUrl"
              @change="handleChange"
              :before-upload="beforeUploadFile"
            >
              <img v-if="ruleForm.groupHeadImg" :src="ruleForm.groupHeadImg" alt="avatar" class="img-avatar"/>
              <div v-else>
                <a-icon type="plus"/>
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
          </div>
        </a-form-model-item>
        <a-form-model-item prop="groupName" label="群名称">
          <a-input v-model="ruleForm.groupName" :maxLength="20" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item prop="groupIntroduction" label="群介绍">
          <a-textarea v-model="ruleForm.groupIntroduction" placeholder="请输入" :maxLength="100"
                      :auto-size="{ minRows: 3, maxRows: 5 }"/>
        </a-form-model-item>
        <a-form-model-item prop="hotChatPersonCount" label="热聊人数">
          <a-input v-model="ruleForm.hotChatPersonCount" :maxLength="10" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item prop="type" label="营销类型">
          <a-select allowClear v-model="ruleForm.type" placeholder="请选择" @change="onOptionsChange"
                    style="max-width:400px;">
            <a-select-option :value="1">加微信好友</a-select-option>
            <a-select-option :value="2">加微信群</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="ruleForm.type==1?'微信二维码名片':'群二维码'" prop="wxQrCode">
          <div class="upload-box">
            <a-upload
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :action="actionImageUrl"
              @change="handleCodeChange"
              :before-upload="beforeUploadFile"
            >
              <img v-if="ruleForm.wxQrCode" :src="ruleForm.wxQrCode" alt="avatar" class="img-avatar"/>
              <div v-else>
                <a-icon type="plus"/>
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
          </div>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存设置</a-button>
          <!-- <a-button>预览</a-button> -->
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
export default {
  name: 'MarketingSetting',
  data() {
    return {
      submitLoading: false,
      actionImageUrl: this.getAppConfig().baseUrl + 'base/upload',
      ruleForm: {
        groupHeadImg: '',// 群头像 ,
        groupIntroduction: '',// 群介绍 ,
        groupName: '',// 群名称 ,
        hotChatPersonCount: '',// 热聊人数 ,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        productDetailStatus: undefined,// 商品详情展示 1开启 2关闭 ,
        showType: undefined,// 展示模式 1公众号吸粉模式 2直接扫码 ,
        type: 1,// 营销类型 1加微信好友 2加微信群 ,
        wxQrCode: ''// 微信二维码名片/群二维码
      },
      rules: {
        productDetailStatus: [
          { required: true, message: '请选择商品详情展示', trigger: 'change' }
        ],
        showType: [
          { required: true, message: '请选择展示模式', trigger: 'change' }
        ],
        groupHeadImg: [
          { required: true, message: '请上传群头像', trigger: 'change' }
        ],
        groupName: [
          { required: true, message: '请输入群名称', trigger: 'blur' }
        ],
        groupIntroduction: [
          { required: true, message: '请输入群介绍', trigger: 'blur' }
        ],
        hotChatPersonCount: [
          { required: true, message: '请输入热聊人数', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正确的热聊人数', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择营销类型', trigger: 'change' }
        ],
        wxQrCode: [
          { required: true, message: '请上传二维码', trigger: 'change' }
        ]
      },
      currentFormLayout: {
        labelCol: {
          xxl: { span: 3 },
          xl: { span: 3 },
          lg: { span: 3 },
          sm: { span: 5 },
          md: { span: 8 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 21 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 21 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 19 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 19 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 3 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 3 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 3 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 5 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 8 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 10 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      }

    }
  },
  mounted() {
    this.getCommunityMarketDetail()
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'MarketingSetting', title: '营销设置' }
    ])
  },
  methods: {
    onOptionsChange(value) {
      this.getLogUtils().logWithTag('onOptionsChange', value)
      this.ruleForm.wxQrCode = ''
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        return
      }
      if (info.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(info.fileList)
        // Get this url from response in real world.
        this.ruleForm.groupHeadImg = url
      }
    },
    handleCodeChange(info) {
      if (info.file.status === 'uploading') {
        return
      }
      if (info.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(info.fileList)
        // Get this url from response in real world.
        this.ruleForm.wxQrCode = url
      }
    },
    getLatestUrlFromFileList(fileList) {
      if (fileList && fileList.length > 0) {
        const lastIndex = fileList.length - 1
        if (fileList[lastIndex] && fileList[lastIndex].response) {
          return fileList[lastIndex].response.data
        }
      }
      return ''
    },
    beforeUploadFile(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG && !isPNG) {
        this.$message.error('请选择正确的图片格式上传!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!')
        return false
      }
      return true
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitLoading = true
      this.getHttpServices().getServerApiService().post('communityMarket/v2/saveCommunityMarket', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('营销设置成功')
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 查询
    getCommunityMarketDetail() {
      this.getHttpServices().getServerApiService().post('communityMarket/v2/getCommunityMarketDetail', {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      }).then(res => {
        this.getLogUtils().logWithTag('getCommunityMarketDetail', res)
        if (res) {
          this.ruleForm = res
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style scoped lang="less">
@import url('../../../CustomPage.less');

.ant-btn + .ant-btn {
  margin-left: 10px;
}

.maxW250 {
  max-width: 250px;
}

.img-avatar {
  width: 100px;
  height: 100px;
}

.pl5 {
  padding-left: 5px;
}

.pr5 {
  padding-right: 5px;
}

.upload-box {
  .avatar-uploader > .ant-upload {
    width: 100px;
    height: 100px;
  }
}
</style>